import { apiCall } from '@/lib/api-client';

export interface SubmitSupportTicketArgs {
  subject: string;
  message: string;
}

export interface SupportTicketResult {
  id: number;
  status: string;
  created_at: string;
}

/** POST /api/support/tickets — file a support request. */
export async function submitSupportTicket(
  args: SubmitSupportTicketArgs,
): Promise<SupportTicketResult> {
  return apiCall<SupportTicketResult>('/api/support/tickets', {
    method: 'POST',
    json: args,
  });
}
